import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAnalysisStore = create(
  persist(
    (set) => ({
      // Analysis wizard state
      step: 1, // 1: Topic & Laws, 2: Processing, 3: Results
      topic: '',
      lawList: [],
      relevantReferences: [],
      judgmentSearchTerms: [],
      synthesisResult: null,
      isWizardOpen: false,
      isLoading: false,
    
      // PDF viewer state
      isPdfModalOpen: false,
      currentPdfPath: null,
      
      // Validation results state
      validationResults: {},
    
      // Actions
      setStep: (step) => set({ step }),
      setTopic: (topic) => set({ topic }),
      setLawList: (lawList) => set({ lawList }),
      addLaw: (law) => set(state => ({ lawList: [...state.lawList, law] })),
      removeLaw: (law) => set(state => ({
        lawList: state.lawList.filter(item => item !== law)
      })),
      setRelevantReferences: (refs) => set({ relevantReferences: refs }),
      setJudgmentSearchTerms: (terms) => set({ judgmentSearchTerms: terms }),
      setSynthesisResult: (result) => set({ synthesisResult: result }),
      setWizardOpen: (isOpen) => set({ isWizardOpen: isOpen }),
      setLoading: (isLoading) => set({ isLoading }),
    
      resetWizard: () => set({
        step: 1,
        topic: '',
        lawList: [],
        relevantReferences: [],
        judgmentSearchTerms: [],
        synthesisResult: null,
        isLoading: false,
      }),
    
      // PDF modal actions
      openPdfModal: (pdfPath) => set({ isPdfModalOpen: true, currentPdfPath: pdfPath }),
      closePdfModal: () => set({ isPdfModalOpen: false, currentPdfPath: null }),
      
      // Validation actions
      setValidationResult: (statement, isValid) => set(state => ({
        validationResults: {
          ...state.validationResults,
          [statement]: isValid
        }
      })),
      
      resetValidationResults: () => set({ validationResults: {} })
    }),
    {
      name: 'analysis-storage',
      partialize: (state) => ({
        // Nur die Validierungsergebnisse werden persistent gespeichert
        validationResults: state.validationResults
      }),
    }
  )
);